import { createSlice } from "@reduxjs/toolkit"

import {
  resetProductPositionUpdatesHandler,
  saveProductPositionUpdatesHandler
} from "./productPositionUpdatesActionHandlers"
import { ProductPositionUpdatesReducerState } from "./types"

const initialState: ProductPositionUpdatesReducerState = {}

const productPositionUpdatesSlice = createSlice({
  name: "productPositionUpdates",
  initialState,
  reducers: {
    saveProductPositionUpdates: saveProductPositionUpdatesHandler,
    resetProductPositionUpdates: resetProductPositionUpdatesHandler
  }
})

export const { saveProductPositionUpdates, resetProductPositionUpdates } =
  productPositionUpdatesSlice.actions

const { actions } = productPositionUpdatesSlice

export { actions }

export default productPositionUpdatesSlice.reducer
